export default "__VITE_ASSET__B8D92Dkk__"